import gql from "graphql-tag";

export const MUTATION_DELETE_CUSTOMER_DATA = gql`
    mutation deleteCustomerData(
        $account_id: String!
        $store_id: String!
        $input: CcpaDeleteCustomerInput!
    ) {
        deleteCustomerData(
            account_id: $account_id
            store_id: $store_id
            input: $input
        ) {
            customer_id
            deleted_at
            deleted_resources {
                count
                resource_ids
                resource_type
            }
            message
            success
        }
    }
`;
